import { Chart } from 'chart.js';
import { toFontString } from 'chart.js/helpers';
const zeroCircleCache = new WeakMap();
const cache = new WeakMap();
export const chartjsPluginWindRose = {
    id: "windRose",
    defaults: {
        zero: {
            display: false,
            value: 0,
            color: 'rgb(26,20,148)',
            textColor: 'rgb(255,255,255)',
            font: {
                ...Chart.defaults.font,
                size: undefined,
            },
            percentOfRadius: 0.15,
        },
        formatter: (value) => value.toString(),
        autoFill: true,
    },
    install(chart) {
        zeroCircleCache.set(chart, {
            anchorX: null,
            anchorY: null,
            radius: null,
        });
        cache.set(chart, {
            onInitUpdate: false,
            forceMin: null,
        });
    },
    beforeDataLimits(chart, { scale }, options) {
        if (!options.zero.display) {
            return;
        }
        const state = cache.get(chart);
        // @ts-ignore
        scale.options.min = state.forceMin;
    },
    afterLayout(chart, args, options) {
        if (!options.zero.display) {
            return;
        }
        const state = cache.get(chart);
        const scale = chart.scales['r'];
        // @ts-ignore
        const scaleRadius = scale?.drawingArea;
        const zeroCircle = zeroCircleCache.get(chart);
        if (scaleRadius === undefined || scaleRadius === null) {
            return;
        }
        zeroCircle.radius = scaleRadius * options.zero.percentOfRadius;
        const value = scale.getValueForDistanceFromCenter(zeroCircle.radius);
        if (value !== state.forceMin) {
            state.forceMin = scale.min - value;
        }
        // @ts-ignore
        zeroCircle.anchorX = scale.xCenter;
        // @ts-ignore
        zeroCircle.anchorY = scale.yCenter;
    },
    afterUpdate(chart, args, options) {
        if (!options.zero.display) {
            return;
        }
        const state = cache.get(chart);
        if (state.onInitUpdate !== true) {
            state.onInitUpdate = true;
            chart.update('none');
        }
    },
    afterDatasetDraw(chart, args, options) {
        if (!options.zero.display) {
            return;
        }
        const zeroCircle = zeroCircleCache.get(chart);
        drawZeroCircle(chart.ctx, zeroCircle, options);
        const text = options.formatter(options.zero.value);
        const radius = zeroCircle.radius || 0;
        const textSize = (radius / text.length);
        const font = {
            ...options.zero.font,
            size: textSize,
        };
        drawZeroText(chart.ctx, zeroCircle, {
            text,
            font: toFontString(font),
            textColor: options.zero.textColor,
        });
    }
};
function drawZeroCircle(ctx, zeroCircle, options) {
    const { anchorX, anchorY, radius } = zeroCircle;
    if (anchorX === null || anchorY === null || radius === null) {
        return;
    }
    ctx.save();
    ctx.beginPath();
    ctx.arc(anchorX, anchorY, radius, 0, 2 * Math.PI);
    ctx.fillStyle = options.zero.color;
    ctx.fill();
    ctx.restore();
}
function drawZeroText(ctx, zeroCircle, options) {
    const { anchorX, anchorY, radius } = zeroCircle;
    const { text, font, textColor } = options;
    if (anchorX === null || anchorY === null || radius === null) {
        return;
    }
    if (text === null || text === undefined) {
        return;
    }
    ctx.save();
    ctx.beginPath();
    ctx.fillStyle = textColor;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = font;
    ctx.fillText(text, anchorX, anchorY);
    ctx.restore();
}
//# sourceMappingURL=WindRose.plugin.js.map
